import { Directive, TemplateRef } from '@angular/core';
import { DocTreeNode } from './doc-tree.types';

export interface DocTreeNodeTemplateContext {
  $implicit: DocTreeNode;
  node: DocTreeNode;
}

@Directive({
  selector: '[docTreeNode]',
  standalone: true,
})
export class DocTreeNodeTemplateDirective {
  constructor(public readonly template: TemplateRef<DocTreeNodeTemplateContext>) {}
}
